import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function FinalCTA() {
  return (
    <section className="section-padding bg-foreground text-primary-foreground">
      <div className="container-narrow text-center">
        <h2 className="font-serif text-3xl font-semibold md:text-4xl lg:text-5xl">
          Let's make this <span className="text-primary">easy</span>.
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg text-primary-foreground/80">
          Your wedding day should be stress-free. Start with a simple consultation and let us handle the rest.
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button variant="hero" size="xl" asChild>
            <Link to="/contact">Check Availability</Link>
          </Button>
          <Button variant="hero-outline" size="xl" className="border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-foreground" asChild>
            <Link to="/combo-packages">View Packages</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
